import { render } from "./ServiceProviderDetail.vue?vue&type=template&id=7000a426"
import script from "./ServiceProviderDetail.vue?vue&type=script&lang=js"
export * from "./ServiceProviderDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__